import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'
const equipRouter: RouteConfig = {
  path: '/equipAnalyseManage',
  redirect: 'noredirect',
  name: 'equipAnalyseManage',
  component: Layout,
  children: [
    {
      path: 'equipAnalyseManage',
      component: () => import('@/views/equipAnalyseManage/index.vue'),
      name: 'equipAnalyseManage',
      meta: {
        title: '器材统计分析',
        icon: 'resource',
        requireAuth: true
      }
    },
  ]

}

export default equipRouter
